module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Layout/Layout-top-panel-5-9a862266b6c12669f56a0b0f0923970f.svg";